import React from 'react';
import { useLanguageStore } from '../store';

export const CookiePage = () => {
  const { language } = useLanguageStore();

  return (
    <div className="container-custom py-16 text-left max-w-4xl select-text">
      {/* РУССКИЙ */}
      {language === 'ru' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">ПОЛИТИКА ИСПОЛЬЗОВАНИЯ COOKIE</h1>
          <p className="text-sm text-muted-foreground">Последнее обновление: 12 августа 2026 г.</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Что такое файлы Cookie?</h2>
            <p>
              ИП Oksana Fedyk / FEDYK Furniture (BE1024640395) использует файлы cookie на своем веб-сайте для обеспечения правильной работы пользовательского интерфейса.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Категории используемых файлов Cookie</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Обязательные (функциональные):</strong> Технические cookie для сохранения выбранного языка (EN, NL, RO, RU), списка избранного и корзины расчетов.</li>
              <li><strong>Аналитические:</strong> Позволяют анонимно анализировать посещаемость сайта (Google Analytics).</li>
            </ul>
          </section>
        </article>
      )}

      {/* НИДЕРЛАНДСКИЙ */}
      {language === 'nl' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">COOKIEBELEID</h1>
          <p className="text-sm text-muted-foreground">Laatst bijgewerkt: 12 augustus 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Wat zijn cookies?</h2>
            <p>
              Eenmanszaak Oksana Fedyk / FEDYK Furniture (BE1024640395) maakt op haar website gebruik van cookies om de gebruikerservaring te optimaliseren.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Welke cookies gebruiken wij?</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Noodzakelijke/Functionele cookies:</strong> Voor het onthouden van de gekozen taal (EN, NL, RO, RU), artikelen in het winkelmandje en offertes.</li>
              <li><strong>Analytische cookies:</strong> Voor geanonimiseerde statistieken over websitebezoek (Google Analytics).</li>
            </ul>
          </section>
        </article>
      )}

      {/* АНГЛИЙСКИЙ */}
      {language === 'en' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">COOKIE POLICY</h1>
          <p className="text-sm text-muted-foreground">Last updated: August 12, 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. What Are Cookies?</h2>
            <p>
              <strong>Oksana Fedyk</strong> (Self-employed), trading as <strong>FEDYK Furniture</strong> (VAT: BE1024640395), uses cookies on its website to ensure proper functionality.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Categories of Cookies We Use</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Essential/Functional Cookies:</strong> Technical cookies to save language preference (EN, NL, RO, RU), wishlist items, and quote requests.</li>
              <li><strong>Analytical Cookies:</strong> To analyze website traffic anonymously (Google Analytics).</li>
            </ul>
          </section>
        </article>
      )}

      {/* РУМЫНСКИЙ */}
      {language === 'ro' && (
        <article className="prose dark:prose-invert max-w-none space-y-6">
          <h1 className="text-3xl font-light uppercase tracking-tight">POLITICA DE COOKIE-URI</h1>
          <p className="text-sm text-muted-foreground">Ultima actualizare: 12 august 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">1. Ce sunt cookie-urile?</h2>
            <p>
              Întreprinderea individuală Oksana Fedyk / FEDYK Furniture (BE1024640395) folosește fișiere cookie pe site-ul său pentru a asigura funcționarea optimă.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-medium">2. Categorii de cookie-uri utilizate</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Esențiale/Funcționale:</strong> Cookie-uri tehnice pentru salvarea limbii selectate (EN, NL, RO, RU) și solicitările de ofertă.</li>
              <li><strong>Analitice:</strong> Pentru analizarea anonimă a traficului pe site (Google Analytics).</li>
            </ul>
          </section>
        </article>
      )}
    </div>
  );
};

export default CookiePage;
